import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from "@angular/material/snack-bar";
import { CustomerService } from "src/app/shared/services/customer.service";
import { DateTimeUtils } from "src/app/shared/util/date-time.utils";

@Component({
    selector: 'app-customer-management',
    templateUrl: './customer-management.component.html',
    styleUrls: ['./customer-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerManagementComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'firstName',
    'email',
    'companyName',
    'lastSignInAt'
  ];

  constructor(
    private router: Router,
    public snackBar: MatSnackBar,
    public customerService: CustomerService,
  ) {}

  ngOnInit(): void {
    this.loadCustomersTable();
  }

  reDirectUrl() {
    this.router.navigate(['dashboard']);
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return '';
    return DateTimeUtils.getLocalDateTimeFromUTCDate(dateString, 'MMMM d, yyyy HH:mm').toString();
  }

  loadCustomersTable() {
    this.customerService.getAllCustomers().subscribe({
      next: (customers) => {
        this.dataSource.data = Array.isArray(customers) ? customers : [customers];
      }
    });
  }

  getFullCompanyLine(customer: any): string {
    const parts = [];

    if (customer.company?.name) parts.push(customer.company.name);
    if (customer.companyAddress?.city?.name) parts.push(customer.companyAddress.city.name);
    if (customer.companyAddress?.state?.name) parts.push(customer.companyAddress.state.name);
    if (customer.companyAddress?.country?.name) parts.push(customer.companyAddress.country.name);

    return parts.join(', ');
  }
}
